import React from "react";
import { motion } from "motion/react";
import "../styles/about.css";

const About = () => {
	return (
		<div id="about">
			<motion.div
				initial={{ opacity: 0, y: 60 }}
				viewport={{ once: true }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{
					duration: 0.8,
				}}
			>
				<div className="about_container">
					<p className="about_title">About</p>
				</div>
				<p className="about_description">
					I'm a professional &nbsp;<span className="artist">3D Artist</span>&nbsp; who
					has undergone intensive web development training and gained hands-on experience building user-friendly, responsive websites. This builds on my previous experience as a <span className="full_stack">UI/UX Designer</span> &nbsp; and <span className="full_stack">Web Developer </span>&nbsp;. I'm
					excited to apply what I've learned and continue growing as a
					developer by tackling real-world projects.
				</p>
			</motion.div>
		</div>
	);
};

export default About;
